import React from 'react';
import PropTypes from 'prop-types';
import AddCircleIcon from '@material-ui/icons/AddCircleOutlineSharp';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircleOutlineSharp';
import { updateViewport } from 'mirador/dist/es/src/state/actions';
import { getViewer } from 'mirador/dist/es/src/state/selectors';
import {MiradorMenuButton} from "mirador/dist/es/src/components/MiradorMenuButton";

const ZoomPluginComponent = ({ zoomIn, zoomOut, t }) => (
    <div style={{ display: 'flex', alignItems: 'center', margin: '0 5px' }}>
        <MiradorMenuButton
            onClick={zoomIn}
            aria-label={t('zoomIn')}
        >
            <AddCircleIcon />
        </MiradorMenuButton>
        <MiradorMenuButton
            onClick={zoomOut}
            aria-label={t('zoomOut')}
        >
            <RemoveCircleIcon />
        </MiradorMenuButton>
    </div>
);

ZoomPluginComponent.propTypes = {
    zoomIn: PropTypes.func.isRequired,
    zoomOut: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

const zoomButtonPlugin =  {
    target: 'WindowTopBarPluginArea',
    mode: 'add',
    component: ZoomPluginComponent,
    mapDispatchToProps: (dispatch, { windowId }) => ({
        zoomIn: () => {
            dispatch((_, getState) => {
                const state = getState();
                const viewer = getViewer(state, { windowId });
                if (!viewer) return;

                const newZoom = (viewer.zoom || 1) * 1.2;
                dispatch(updateViewport(windowId, { zoom: newZoom }));
            });
        },
        zoomOut: () => {
            dispatch((_, getState) => {
                const state = getState();
                const viewer = getViewer(state, { windowId });
                if (!viewer) return;

                const newZoom = (viewer.zoom || 1) * 0.8;
                dispatch(updateViewport(windowId, { zoom: newZoom }));
            });
        }
    }),
};

export { zoomButtonPlugin };
